import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

export default function Coordinate_Render(props) {
  const { setNodeData, nodeData } = props;
  const [angle, setAngle] = useState(nodeData.type === "coordinate"? nodeData.angle: "");
  const [x, setX] = useState(nodeData.type === "coordinate"? nodeData.x: "")
  const [y, setY] = useState(nodeData.type === "coordinate"? nodeData.y: "")

  setNodeData({
    type: "coordinate",
    angle: angle,
    x: x,
    y: y,
  })

  const handleChangeAngle = (event) => {
    setAngle(event.target.value)
    setNodeData({
      type: "coordinate",
      angle: event.target.value,
      x: x,
      y: y,
    })
  }

  const handleChangeX = (event) => {
    setX(event.target.value)
    setNodeData({
      type: "coordinate",
      angle: angle,
      x: event.target.value,
      y: y
    })
  }

  const handleChangeY = (event) => {
    setY(event.target.value)
    setNodeData({
      type: "coordinate",
      angle: angle,
      x: x,
      y: event.target.value
    })
  }

  return(<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <TextField
      id="outlined-required"
      label="Angle"
      value={angle}
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChangeAngle}
    >
    </TextField>
    <TextField
      id="outlined-required"
      label="X"
      value={x}
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChangeX}
    >
    </TextField>
    <TextField
      id="outlined-required"
      label="Y"
      value={y}
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChangeY}
    >
    </TextField>
  </Grid>
  )
}